import React from 'react';

export default function UnitsTable({ units, onUnitUpdateOrDelete }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="units-table-table" className="table">
				<thead>
					<tr>
						<th>Name</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{units
						? units.map(unit => (
								<tr key={unit.id}>
									<td>{unit.unit_name}</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onUnitUpdateOrDelete(unit)}
										/>
										<i
											data-toggle="modal"
											data-target="#oneInputEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onUnitUpdateOrDelete(unit)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
